// añadir evento click al botón de búsqueda añadiendo la clase is-pressed
document.querySelector('.utad-search-form__button').addEventListener('click', function() {
    this.classList.toggle('is-pressed');
    document.querySelector('.utad-search-form').classList.toggle('is-active');
});